$(document).on('submit', '#form-search', function(e) {
    e.preventDefault();
    searchValue();
});

var isOpenAdvancedSearch = false;
$(document).on('click', '#busca-avancada-select', function() {
    $('#busca-avancada').slideToggle({
        duration: 'fast',
    });

    isOpenAdvancedSearch ? closeAdvancedSearch() : openAdvancedSearch();
});

function openAdvancedSearch() {
    isOpenAdvancedSearch = true;

    $('#busca-avancada-input').css('background-image', 'url("/images/square-caret-up-solid.svg")');

    $('#input-search').removeClass('border-default');
    $('#input-search').css('border-bottom', 'none');
    $('#input-search').css('border-radius', '6px 6px 0 0');
}

function closeAdvancedSearch() {
    isOpenAdvancedSearch = false;

    $('#busca-avancada-input').css('background-image', 'url("/images/square-caret-down-solid.svg")');

    $('#input-search').addClass('border-default');
    $('#input-search').css('border-bottom', '1px solid #8A9FA0');
    $('#input-search').css('border-radius', '6px');
}

function searchValue() {
    var search = $('#input-search').val();
    if (!search) {
        return;
    }

    var tipo = $('input[name=tipo-publicacao]:checked').val();
    var local = $('input[name=local-pesquisado]:checked').val();
    var ordenacao = $('input[name=tipo-ordenacao]:checked').val();
    var data = $('input[name=date-search]:checked').val();

    location.href = '/search/?search=' + search +
        '&type=' + tipo +
        '&location=' + local +
        '&order=' + ordenacao +
        '&date=' + data;
}
